angular.module('unergie.main')
.controller('nominationsCtrl', ($scope, $state, ApiUser, DataAccess, DataAccessSearch, MS, AlertManager, FileUploader,
    TableGeneratorService, ModalService, ReferencesService, DownloadService, ErrorCatcher, BoFeaturesService) => {
    $scope.isActive = (state) => $state.is(state)

    $scope.sumBy = (array, id) => MS.round(_.sumBy(array, id), 1)

    const ENV = BoFeaturesService.getEnv()

    $scope.nominations = {
        refreshing: false,
        show: {},
        counts: [10, 25, 50, 100],
        columns: {
            id: { label: 'ID', mode: 'search_operator' },
            date: { label: 'Jour', mode: 'search_date' },
            nomination_day: { label: 'Jour de nomination', mode: 'search_date' },
            version: { label: 'Version', mode: 'search_wildcard' },
            status: { label: 'Statut', mode: 'search_wildcard' },
            rte_status: { label: 'Statut RTE', mode: 'search_wildcard' },
            axpo_status: { label: 'Statut AXPO', mode: 'search_wildcard' },
            rte_file: { label: 'Fichier RTE', mode: 'hidden' },
            axpo_file: { label: 'Fichier AXPO', mode: 'hidden' },
            errors: { label: 'Erreurs', mode: 'hidden' },
            total: { label: 'Code erreur', mode: 'filter_only' },
        },
    }

    // UPLOADER
    $scope.provisionUploader = new FileUploader({
        url: `/api-admin/s3-upload`,
        alias: 'file',
        formData: [{ bucketName: 'files', path: 'nomination-provision' }],
        autoUpload: true,
        method: 'POST',
        onSuccessItem(item, response, status, headers) {
            AlertManager.success(`Fichier de provision uploadé`)
        },
        onErrorItem(item, response, status, headers) {
            AlertManager.error(response.message, 10000)
        },
    })

    $scope.refreshNomination = (nomination) => {
        nomination.refreshing = true
        return DataAccess.getNominationsFormatted({ id: nomination.id }).$promise.then((formatResult) => {
            nomination.formatted = formatResult.toJSON()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            nomination.refreshing = false
        })
    }

    $scope.toggleExpand = function (nomination) {
        if (!nomination.refreshing) {
            nomination.expanded = !nomination.expanded
            if (!nomination.fetched) {
                return $scope.refreshNomination(nomination)
            }
        }
    }

    $scope.download = (file, e) => {
        e.preventDefault()
        e.stopPropagation()
        DownloadService.s3Download(`s3://${ENV}-unergie-files/${file}`)
    }

    $scope.sendPayload = {
        to: 'both',
    }

    $scope.sendFields = {
        to: {
            label: 'A',
            type: 'radio',
            enum: [
                { value: 'both', label: 'Axpo + RTE' },
                { value: 'axpo', label: 'Axpo' },
                { value: 'rte', label: 'RTE' },
            ],
        },
    }

    $scope.prepareSendPayload = (nomination) => {
        nomination.closeSend = false
        _.each(_.filter($scope.nominations.instance.data, (n) => n.id !== nomination.id), (c) => {
            c.closeSend = true
        })
        $scope.sendFields.to.enum = []
        if (nomination.rte_status !== 'SENT') {
            $scope.sendFields.to.enum.push({ value: 'rte', label: 'RTE' })
            $scope.sendPayload.to = 'rte'
        }
        if (nomination.axpo_status !== 'SENT') {
            $scope.sendFields.to.enum.push({ value: 'axpo', label: 'Axpo' })
            $scope.sendPayload.to = 'axpo'
        }
        if (nomination.rte_status !== 'SENT' && nomination.axpo_status !== 'SENT') {
            $scope.sendFields.to.enum.push({ value: 'both', label: 'Axpo + RTE' })
            $scope.sendPayload.to = 'both'
        }
    }

    $scope.canSend = (nomination) => !['OK'].includes(nomination.status)

    $scope.sendNomination = (nomination) => {
        nomination.sending = true
        return ApiUser.sendNomination({ id: nomination.id, to: $scope.sendPayload.to }, {}).$promise.then((result) => {
            AlertManager.success('Nomination envoyée !')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshNominations()
            nomination.sending = false
        })
    }

    $scope.canDelete = (nomination) => nomination.rte_status !== 'SENT' && nomination.axpo_status !== 'SENT'

    $scope.delete = (nomination) => {
        nomination.deleting = true
        return DataAccess.deleteNomination({ id: nomination.id }).$promise.then((result) => {
            AlertManager.success('Nomination supprimée !')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshNominations()
            nomination.deleting = false
        })
    }

    $scope.nominatePayload = {
        date: moment().format('YYYY-MM-DD'),
        mode: 'simu',
        new: false,
    }

    $scope.nominateFields = {
        date: {
            label: 'Date',
            type: 'date',
        },
        mode: {
            label: 'Mode',
            type: 'radio',
            enum: [
                { value: 'explain', label: 'Retour détaillé' },
                { value: 'simu', label: 'Simulation' },
                { value: 'store', label: 'Lancer' },
                { value: 'send', label: 'Lancer + envoyer' },
            ],
        },
        new: {
            label: 'Nouvelle version',
            type: 'checkbox',
        },
    }

    $scope.nominate = () => {
        $scope.nominating = true
        const query = {
            mode: $scope.nominatePayload.mode,
            date: moment($scope.nominatePayload.date).format('YYYY-MM-DD'),
            new: $scope.nominatePayload.new,
        }
        return ApiUser.runNomination(query, {}).$promise.then((result) => {
            if (['explain', 'simu'].includes($scope.nominatePayload.mode)) {
                ModalService.openModal({ type: 'resultModal', size: 'lg' }, { result })
            } else {
                AlertManager.success('Nomination ok !')
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            if (['store', 'send'].includes($scope.nominatePayload.mode)) {
                $scope.refreshNominations()
            }
            $scope.nominating = false
        })
    }

    $scope.forecastsPayload = {
        date: moment().format('YYYY-MM-DD'),
    }

    $scope.forecastsFields = {
        date: {
            label: 'Semaine du :',
            type: 'date',
        },
    }

    $scope.fetchForecasts = () => {
        $scope.fetchingForecasts = true
        const query = {
            date: moment($scope.forecastsPayload.date).format('YYYY-MM-DD'),
        }
        return ApiUser.fetchForecasts(query, {}).$promise.then((result) => {
            ModalService.openModal({ type: 'resultModal', size: 'lg' }, { result })
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingForecasts = false
        })
    }

    const transform = (nominations) => {
        _.each(nominations, (n) => {
            n.total = MS.round(_.sumBy(n['result-details'], 'value'), 1)
        })
    }

    const activate = () => {
        TableGeneratorService.getTable($scope.nominations, 'nom-results', 'result-details', transform, { orderBy: '-date' })
    }

    $scope.refreshNominations = activate
    activate()
})
